// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comparison-overlay{
    position:fixed;
    height:100%;
    width:100%;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:9;
    background:white;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/common/overlays/comparison/comparison.overlay.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,WAAW;IACX,UAAU;IACV,KAAK;IACL,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gBAAgB;AACpB","sourcesContent":[".comparison-overlay{\n    position:fixed;\n    height:100%;\n    width:100%;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    z-index:9;\n    background:white;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
